<template>
  <div class="row w-100 m-0 mt-3 mb-3"
  :class="{ 'normal-item': this.isAcryl,'option-item':!this.isAcryl }">
    <div class="col-7 m-0 p-1 h-100 wrapper position-relative" >
      <img  :src="itemData.previewFilePath" class="img-fluid w-100 border border-1"/>
      <div v-if="isAcryl" class="acryl-size"><div class="acryl-size-font fw-bold">{{getSize}}</div></div>
    </div>
    <div v-if="isAcryl" class="col p-0 text-start" style="height: 100%; width: 100px;">
      <div class="pe-2">
        <p class="my-0 small">金額(税別)</p>
        <p class="text-end my-0 p-0 fw-bold">{{getPrice}}円</p>
        <hr class="mt-0 mb-1 pe-2">
      </div>
      <div v-if="getDiscountRatio != 0" class="pe-2">
        <p class="my-0 small">割引金額({{getDiscountRatio}}%)</p>
        <p class="text-end my-0 p-0 fw-bold status-error-color">-{{getDiscount}}円</p>
        <hr class="mt-0 mb-1">
      </div>
      <div class="pe-2">
        <p class="my-0 small">数量</p>
        <p class="text-end my-0 p-0 fw-bold">{{this.itemData.quantity}}</p>
        <hr class="mt-0 mb-1">
      </div>
      <div v-if="getDiscountRatio == 0" style="height:46px"/>

      <!-- <p class="my-0 small">サイズ</p>
      <p class="text-end my-0 p-0 fw-bold">{{getSize}}</p>
      <hr class="mt-0 mb-1"> -->
      <button @click="onClickDesignPreview(itemData.previewFilePath)" class="acry-btn-secondary-normal btn-size"  >プレビュー</button>
      <button @click="onClickEdit" class="acry-btn-secondary-normal btn-size" >再編集</button>
      <button @click="onClickDelete" class="acry-btn-primary-normal btn-size" >削除</button>
    </div>
    <div v-if="!isAcryl" class="col p-0 text-start" style="height: 100%">
      <div class="pe-2">
        <p class="my-0 small">数量</p>
        <p class="text-end my-0 p-0 fw-bold">{{this.itemData.quantity}}</p>
        <hr class="mt-0 mb-1">
      </div>
      <div class="pe-2">
        <p class="my-0 small">金額(税別)</p>
        <p class="text-end my-0 p-0 fw-bold">{{getPrice}}円</p>
        <hr class="mt-0 mb-1">
      </div>
      <button @click="onClickOptionPreview(itemData.previewFilePath)" class="acry-btn-secondary-normal btn-size"  >プレビュー</button>
      <button @click="onClickDelete" class="acry-btn-primary-normal btn-size" >削除</button>
    </div>
  </div>
</template>

<script>
import { ProductId, AcrylProductIds, GetAcryProductPrice } from "@/js/Const.js"
import { ProductData } from "@/js/ProductData.js";
import { FirebaseCommon } from "@/js/FirebaseCommon.js";
import { CenterViewState, RightViewState, GetCanvasSize } from "@/js/Const.js";
import { CreateImageElement, CreateFrameCutlineImage, DiscountRatio } from "@/js/CommonFunc.js";
import { OffScreen } from "@/js/OffScreen.js";
import JSZip from "jszip";

import firebase from "firebase/app";
import "firebase/database";
import "firebase/storage";


export default {
  name: "CartItem",
  props: ["itemData"],
  data: function () {
    return {
    };
  },
  created(){
  },
  watch:{

  },
  computed: {
    isAcryl(){
      return AcrylProductIds.includes(this.itemData.productId)
    },
    getSize(){
      switch(this.itemData.productId){
        case ProductId.S:
        case ProductId.S_SVG:
        case ProductId.S_SHARE:
          return "S";
        case ProductId.M:
        case ProductId.M_SVG:
        case ProductId.M_SHARE:
          return "M";
        case ProductId.L:
        case ProductId.L_SVG:
        case ProductId.L_SHARE:
          return "L";
        default: return "";
      }
    },
    getPrice(){
      if( this.isAcryl ){
        return GetAcryProductPrice(this.itemData.productId).priceBase * this.itemData.quantity;
      }else{
        return (this.$store.state.optionManager.getOptionDataForProductId(this.itemData.productId)?.priceBase ?? 0) * this.itemData.quantity;
      }
    },
    getDiscountRatio(){
      return DiscountRatio(this.$store.state.cartManager.getCartProductQuantity(this.itemData.productId));
    },
    getDiscount(){
      let quantity = this.$store.state.cartManager.getCartProductQuantity(this.itemData.productId);
      let saleProduct = this.$store.state.saleProductManager.getProduct(this.itemData.productId);
      if(!saleProduct || !saleProduct.productData) return;  // 初期化がまだの場合があるので
      const ProductPrice = GetAcryProductPrice(this.itemData.productId);
      return ProductPrice.priceBase * this.itemData.quantity * (DiscountRatio(quantity) / 100);
    }
  },
  methods:{

    onClickDesignPreview(url){
      this.$store.commit("showImagePreview", url);
    },
    onClickOptionPreview(url){
      this.$store.commit("showImagePreview", url);
    },

    async onClickEdit(){
      this.$store.commit("showLoading");

      // zipをダウンロードしてjsonを解析
      let url = await firebase.storage().ref().child(FirebaseCommon.getBaseFilePath() + FirebaseCommon.getZipFileName(this.itemData.tempId)).getDownloadURL();
      let info = {};
      info.zipData = await this.downloadZip(url);
      let str = await info.zipData.file(this.itemData.tempId + "/product.json").async('string');
      info.productJson = JSON.parse(str);

      await this.$store.state.saleProductManager.update().catch((e) => {
        this.$common.log(e);
        this.$store.commit("hideLoading");
        this.$store.commit("showMessage", "エラーが発生しました");
        this.$store.commit("hideLoading");
        return;
      });

      let saleProduct = this.$store.state.saleProductManager.getProduct(this.itemData.productId);
      let p = new ProductData(
        saleProduct,
        saleProduct.productData["product_class_list2"][0]
      );
      this.$store.commit("setSelectProductId", this.itemData.productId);

      p.createDataForJson( info, this.itemData.tempId );
      p.setCartId(this.itemData.tempId);  // 再編集タイプ
      let canvasSize = GetCanvasSize(this.itemData.productId);

      // デザインファイル
      const designImageUrl = await FirebaseCommon.getImageUrl(FirebaseCommon.getDesignFileName(this.itemData.tempId));
      const designFile = await this.downloadPngImage(designImageUrl);
      this.$store.commit('setDesignImageFile', designFile);
      this.$store.commit('setDesignImageURL', URL.createObjectURL(designFile));

      // カットラインファイル
      let cutlineImageUrl = "";
      let cutlineFile = null;
      if( info.productJson.isShareCodeDraft ){
        // pngカットライン
        cutlineImageUrl = await FirebaseCommon.getImageUrl(FirebaseCommon.getPngCutlineFileName(this.itemData.tempId));
        cutlineFile = await this.downloadPngImage(cutlineImageUrl);
        this.$store.commit('setScCutlineImageFile', cutlineFile);
        this.$store.commit('setScCutlineImageURL', URL.createObjectURL(cutlineFile));
        // 画像の輪郭を抽出
        let blob = await CreateFrameCutlineImage(cutlineImageUrl, canvasSize.width, canvasSize.height);
        this.$store.commit('setFrameCutlineImageFile', blob);
        this.$store.commit('setFrameCutlineImageURL', URL.createObjectURL(blob));
      }else{
        // svgカットライン
        cutlineImageUrl = await FirebaseCommon.getImageUrl(FirebaseCommon.getSvgCutlineFileName(this.itemData.tempId));
        cutlineFile = await this.downloadSvgImage(cutlineImageUrl);
        this.$store.commit('setCutlineImageFile', cutlineFile);
        this.$store.commit('setCutlineImageURL', URL.createObjectURL(cutlineFile));

        let offScreen = new OffScreen(canvasSize.width, canvasSize.height);
        let image = await CreateImageElement(cutlineImageUrl);
        offScreen.drawImage(image, 0, 0, canvasSize.width, canvasSize.height);
        const blob = await new Promise( (resolve)=>{ offScreen.toBlob(function(blob){ resolve(blob); }) });
        this.$store.commit('setFrameCutlineImageFile', blob);
        this.$store.commit('setFrameCutlineImageURL', URL.createObjectURL(blob));
      }

      this.$store.commit("setIsShareCodeDraft", info.productJson.isShareCodeDraft);

      this.$store.commit("addProduct", p);
      this.$store.commit("hideModal");
      this.$store.commit("selectCanvasData", p.canvasDatas[0]);
      this.$store.commit("hideLoading");

      await this.$store.state.currentCanvasData.setBaseImage(
        this.$store.state.designImageFile,
        this.$store.state.designImageURL,
        cutlineFile,
        this.$store.state.frameCutlineImageURL
      );

      if( this.itemData.isSimple ){
        this.$store.commit("setSelectProductId", this.itemData.productId);
        this.$store.commit("setCenterViewState", CenterViewState.Preview);
        this.$store.commit('setRightViewState', RightViewState.Preview);
      }else{
        // 編集用のUIに変更
        this.$store.commit('setCenterViewState', CenterViewState.Edit);
        this.$store.commit('setRightViewState', RightViewState.Edit);
      }

      // カートを非表示に変更
      this.$store.commit("switchShowCart");

    },
    async onClickDelete(){
      this.$store.commit("setYesNoDialogCallback", this.deleteProcess);
      this.$store.commit("showYesNoDialog", `カートから削除します。
よろしいですか？`);
    },

    async deleteProcess(){
      this.$store.commit("showLoading");
      if( this.isAcryl ){
        await this.$store.state.cartManager.delete(this.itemData.tempId);
      }else{
        await this.$store.state.cartManager.deleteOption(this.itemData.productId);
      }

      this.$store.commit("hideLoading");
    },

    downloadZip(url){
      console.log("download zip :" + url);
      return new Promise((resolve) => {
        this.$blankAxios
          .get(url,{ responseType: 'arraybuffer', headers: { Accept: 'application/zip' },})
          .then((response) => {
            const blob = new Blob([response.data], { type: "application/zip" });
            const file = new File([blob], "", {});
            JSZip.loadAsync(file).then((res) => {
              resolve(res);
            });
          })
          .catch(() => {
            resolve();
          });
      });
    },
    downloadPngImage(url){
      console.log("download image :" + url);
      return new Promise((resolve) => {
        this.$blankAxios
          .get(url,{ responseType: 'arraybuffer', headers: { Accept: 'image/png' },})
          .then((response) => {
            const blob = new Blob([response.data], { type: "image/png" });
            const file = new File([blob], "", {});
            resolve(file);
          })
          .catch(() => {
            resolve();
          });
      });
    },
    downloadSvgImage(url){
      console.log("download image :" + url);
      return new Promise((resolve) => {
        this.$blankAxios
          .get(url,{ responseType: 'arraybuffer', headers: { Accept: 'image/svg+xml' },})
          .then((response) => {
            const blob = new Blob([response.data], { type: "image/svg+xml" });
            const file = new File([blob], "", {});
            resolve(file);
          })
          .catch(() => {
            resolve();
          });
      });
    },

  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

.item-image{
  background-color: red;
}

.title-text{
  font-size: 1em;
  color: #565959;
}

.value-field{
  border: solid 0px #FFFFFF;
  border-radius:  0px;
  background-color: #E6E5EB;
  color: #565959;
}

.white-btn{
  font-size: 1em;
  height: 33px;
  border: solid 1.5px #565959;
  border-radius:  3px;
  background-color: #FFFFFF;
  color: #565959;
}

.red-btn{
  font-size: 1em;
  border: solid 2px #9C6362;
  border-radius:  3px;
  background-color: #9C6362;
  color: #ffffff;
}
.wrapper {
    display: flex;
    justify-content: center; /*左右中央揃え*/
    align-items: center;     /*上下中央揃え*/
}
.btn-size{
  height:28px;
  width:110px;
  margin-top: 1px;
  font-size: small;
  font-weight: bold;
}
.option-item {
  height: 160px;
  flex-wrap: nowrap;
}
.normal-item {
  height: 236px;
}
.acryl-size{
  position: absolute;
  left: 7px;
  top: 2px;
  width: 40px;
  height: 40px;
  color: $text-white-color;
  background: $primary-main-color;
  border-radius: 50%;
}
.acryl-size-font{
  font-size: 20px;
  margin: 4px;
}
</style>